import { Button, Grid } from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import './guarantor.css';
import CustomisedButton from '../../../components/button/button';
import { Formik } from 'formik';
import { IAddCustomerInfoForInquiryRequest } from '../../../models/registration.model';
import CustomisedDatePicker from '../../../components/datePicker/datePicker';
import CustomisedTextField from '../../../components/textField/textField';
import { newDate } from '@persian-tools/persian-mobile-datepicker';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeRouteType, getNextInnerState, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import { setHeaderTitle } from '../../../redux/headerTitle/headerTitleSlice';
import { useMutation, useQueryClient } from 'react-query';
import { addGuarantor } from '../../../services/guarantor.service';
import { IAddGuarantorReqsponse, IAddGuarantorRequest, IGetGuarantorsResponse } from '../../../models/guarantor.model';
import { IGuarantorContainer } from '../../navigationButtonComponents/guarantorContainer/TGuarantorContainer';
import { useAppBar } from '../../../components/appBar/appBarContext';
import { setGuarantorInfo } from '../../../redux/guarantor/guarantorInfoSlice';
import { GUARANTOR_MOBILE, GUARANTOR_REQUIRED_OTP, GUARANTOR_RESULT } from '../../../config/cacheKey';
import { v4 as uuid } from 'uuid';
import { RootState } from '../../../redux/store';
import DatePickerComponents from '../../../components/datePicker/datePickerComponents';

export default function GuarantorInfo({ setStep, setInnerState, referenceKey }: IGuarantorContainer) {
    const [selectedCount, setSelectedPart] = useState();
    const [mobile, setMobile] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [postalCode, setPostalCode] = useState<string>('');
    const [birthday, setBirthday] = useState<Date>();
    const yupMobileMax = 11;
    const yupPostalCodeMax = 10;
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    const randomKeyForDispatch = Math.random();
    const guarantorTitle = useSelector(
        (state: RootState) => state.guarantorInfo.guarantorTitle
    );
    const guarantorKey = useSelector(
        (state: RootState) => state.guarantorInfo.guarantorKey
    );
    let getData = {} as IGetGuarantorsResponse[];
    let value: any;
    const [width, setWidth] = useState(window.innerWidth);
    const [mobileWidth, setMobileWidth] = useState(window.innerWidth <= 500);
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
        setMobileWidth(window.innerWidth <= 500);
    }

    useEffect(() => {
        dispatch(changeRouteType({ routeType: 'guarantorIntroduce' }));
        // dispatch(
        //     setHeaderTitle({
        //         header: 'اطلاعات ضامن',
        //         parentRoute: 'guarantorIntroduce',
        //     })
        // );
        setHeader('اطلاعات ضامن', 'guarantor');
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'guarantorIntroduce' + randomKeyForDispatch }));
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, [])

    const handleGuarantor = (guarantorTitle: string) => {
        dispatch(setGuarantorInfo({ guarantorTitle }));
        setInnerState!('guarantorInfo');
    };

    const handleContinue = () => {

        // dispatch(getNextInnerState({ nextInnerState: `formLists ${randomKeyForDispatch} ` }));

    }

    function handleDateChange(event: any, key: string, value: Date) {
        // setFormInfo({ ...formInfo, [key]: value as Date });
        setBirthday(value);
    }
    const nationalCodeHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;
        if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
            event.preventDefault();
        }
        if (
            event.target.value.length >= yupPostalCodeMax &&
            key != 8 &&
            key != 46 &&
            selectedCount === 0
        ) {
            event.preventDefault();
        }
    };
    const mobileNumberCodeHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;
        if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
            event.preventDefault();
        }
        if (
            event.target.value.length >= yupMobileMax &&
            key != 8 &&
            key != 46 &&
            selectedCount === 0
        ) {
            event.preventDefault();
        }
    };
    const postalCodeHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;
        if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
            event.preventDefault();
        }
        if (
            event.target.value.length >= yupPostalCodeMax &&
            key != 8 &&
            key != 46 &&
            selectedCount === 0
        ) {
            event.preventDefault();
        }
    };
    const currentSelection = (e: any) => {
        setSelectedPart(
            e.target.value.substring(
                e.target.selectionStart,
                e.target.selectionEnd
            ).length
        );
    };
    const getMobileNumber = (e: any) => {
        setMobile(e.target.value);
    };
    const getNationalCode = (e: any) => {
        setNationalCode(e.target.value);
    };
    const getPostalCode = (e: any) => {
        setPostalCode(e.target.value);
    };

    const { mutate: AddGuarantorMutate } = useMutation(
        addGuarantor,
        {
            onSuccess: (data: IAddGuarantorReqsponse) => {
                if (data) {
                    const guarantorKey = data.key;
                    queryClient.setQueryData(GUARANTOR_MOBILE, mobile);
                    dispatch(setGuarantorInfo({ guarantorTitle, guarantorKey }));
                    if (data.inquiryResult.requiredOtpValidation) {
                        setInnerState!('otp');
                        queryClient.setQueryData(GUARANTOR_REQUIRED_OTP, data.inquiryResult.requiredOtpValidation);
                    }
                    else if (data?.inquiryResult?.inquiries.length > 0) {
                        setInnerState!('guarantorInquiryResult')
                        queryClient.setQueryData(GUARANTOR_RESULT, data.inquiryResult.inquiries);
                    }
                    else {
                        setStep(uuid);
                    }
                }
            },
        }
    );

    function fromDateToString(date: Date): string {
        date = new Date(+date);
        date.setTime(date.getTime() - (date.getTimezoneOffset() * 60000));
        let dateAsString = date.toISOString().substr(0, 19);
        return dateAsString;
    }

    const buttonRef = useRef<any>(null)
    return (
        <>
            <div className="container-height-drawer">
                <div className='content-container'>
                    <div className='drawer-content'>
                        <Formik
                            initialValues={{} as IAddGuarantorRequest}
                            onSubmit={(values: IAddGuarantorRequest) => {
                                values.birthDate = value !== null && value !== undefined ? birthday!.toString() : fromDateToString(birthday!);
                                values.mobileNumber = mobile;
                                values.nationalCode = nationalCode;
                                values.postalCode = postalCode;
                                values.referenceKey = referenceKey!;
                                AddGuarantorMutate(values)
                            }}
                        >
                            {({
                                handleSubmit,
                                handleChange,
                                values,
                                errors,
                                touched,
                                handleBlur,
                            }) => (
                                <form
                                    onSubmit={handleSubmit}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSubmit();
                                        }
                                    }}
                                >
                                    <div
                                        className="centerClass"
                                        style={{
                                            paddingTop: '1.9rem',
                                        }}
                                    >
                                        <Grid
                                            container
                                            className="row"
                                            spacing={2}
                                            style={{
                                                alignItems: 'center',
                                                width: '100%',
                                                margin: 'auto',
                                                marginLeft: '0px'
                                            }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    paddingTop: '1.9rem',
                                                    paddingRight: '2vh'
                                                }}
                                            >
                                                <CustomisedTextField
                                                    autoFocus={false}
                                                    helperText={
                                                        !touched.nationalCode
                                                            ? errors.nationalCode
                                                            : ''
                                                    }
                                                    error={
                                                        !touched.nationalCode &&
                                                        Boolean(errors.nationalCode)
                                                    }
                                                    label="کد ملی"
                                                    placeholder={'0012345678'}
                                                    required={true}
                                                    inputProps={{ type: 'number', inputMode: 'numeric', lang: 'en' }}
                                                    value={nationalCode}
                                                    onChange={getNationalCode}
                                                    name="nationalCode"
                                                    id="nationalCode"
                                                    onKeyDown={nationalCodeHandleKeyDown}
                                                    onSelect={currentSelection}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    paddingTop: '1.9rem',
                                                    paddingRight: '2vh'
                                                }}
                                            >
                                                {
                                                    mobileWidth ?
                                                        <CustomisedDatePicker
                                                            value={birthday as Date}
                                                            label={'تاریخ تولد *'}
                                                            placeHolder="تاریخ تولد"
                                                            helperText={'تاریخ تولد'}
                                                            onChange={(value: any) =>
                                                                handleDateChange(
                                                                    null,
                                                                    'brithDate',
                                                                    value
                                                                )
                                                            }
                                                        /> :
                                                        <DatePickerComponents
                                                            value={birthday}
                                                            label={"تاریخ تولد *"}
                                                            onChange={(value: any) => {
                                                                handleDateChange(
                                                                    null,
                                                                    'brithDate',
                                                                    value
                                                                )
                                                            }}
                                                        />
                                                }
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    paddingTop: '1.9rem',
                                                    paddingRight: '2vh'
                                                }}
                                            >
                                                <CustomisedTextField
                                                    helperText={
                                                        !touched.mobileNumber
                                                            ? errors.mobileNumber
                                                            : ''
                                                    }
                                                    error={
                                                        !touched.mobileNumber &&
                                                        Boolean(errors.mobileNumber)
                                                    }
                                                    label="شماره موبایل"
                                                    placeholder={'091212354567'}
                                                    required={true}
                                                    inputProps={{ type: 'tel', maxLength: 11, pattern: "[0-9]*", inputMode: 'numeric', lang: 'en' }}
                                                    value={mobile}
                                                    onChange={getMobileNumber}
                                                    name="mobileNumber"
                                                    id="mobileNumber"
                                                    onKeyDown={
                                                        mobileNumberCodeHandleKeyDown
                                                    }
                                                    onSelect={currentSelection}
                                                    onBlur={handleBlur}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    paddingTop: '1.9rem',
                                                    paddingRight: '2vh'
                                                }}
                                            >
                                                <CustomisedTextField
                                                    autoFocus={false}
                                                    helperText={
                                                        !touched.postalCode
                                                            ? errors.postalCode
                                                            : ''
                                                    }
                                                    error={
                                                        !touched.postalCode &&
                                                        Boolean(errors.postalCode)
                                                    }
                                                    label="کد پستی"
                                                    placeholder={'98765432198'}
                                                    required={true}
                                                    inputProps={{ type: 'number' }}
                                                    value={postalCode}
                                                    onChange={getPostalCode}
                                                    name="postalCode"
                                                    id="postalCode"
                                                    onKeyDown={postalCodeHandleKeyDown}
                                                    onSelect={currentSelection}
                                                />
                                            </Grid>

                                        </Grid>
                                    </div>
                                    <div
                                        className="centerClass"
                                        style={{
                                            bottom: '10vh',
                                            width: '100%',
                                            paddingTop: '1.5rem',
                                        }}
                                    >
                                        <div className="button-container" >
                                            <Button
                                                onClick={() =>
                                                    handleContinue
                                                }
                                                type="submit"
                                                ref={buttonRef}
                                                style={{ display: "none" }}
                                            ></Button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            onClick={() => {
                                if (buttonRef.current) {
                                    buttonRef.current.click()
                                }

                            }}
                            title='ثبت و ادامه'
                            type='button'
                            disable={nationalCode !== "" && birthday !== undefined
                                && mobile !== "" && postalCode !== "" ? false : true
                            }

                        />

                    </div>
                </div>
            </div>
        </>
    );
}
